// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/theme." + {"404":"2e3871b8290ce59d7d44","collection":"2953a0f0221a1a2cb62d","cart":"32923330c230f5845da6","page.utility":"2e3871b8290ce59d7d44","blog":"81ee8b584ecfc71cbca3","article":"660f7526fb1810f594ae","customers":"ee9b8de7a69e6dd818c3","password":"91a21c33eb9d425995a5"}[chunkId] + ".css";
};